import React from 'react';
import { SparklesIcon, WrenchIcon, StethoscopeIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { audiences } from '../data/content';
const icons = [SparklesIcon, WrenchIcon, StethoscopeIcon];
export function Audience() {
  return <section className="w-full bg-ivory px-5 py-16 md:px-8 md:py-24" data-id="element-22" data-mp="6sd61hsqgcuk">
      <div className="mx-auto max-w-5xl" data-id="element-23" data-mp="1u3av770dc8y">
        <h2 className="text-center font-serif text-[1.85rem] font-extrabold leading-tight text-navy-900 sm:text-4xl md:text-5xl" data-id="element-24" data-mp="gsnj92erpk9q">
          Created for dental professionals who need practical clinical workflows
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-25" data-mp="plh37d55t7tx">
          <strong className="text-navy-900" data-id="element-26" data-mp="ljdngcbgjh2u">Not another general textbook about cosmetic dentistry.</strong>{' '}
          Designed for professionals who already understand the importance of clinical judgment and
          want a more structured way to organize complication-related information.
        </p>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-27" data-mp="16driskdvsnkg">
          {audiences.map((a, i) => {
          const Icon = icons[i];
          return <div key={a.title} className="flex flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-navy-900/10" data-id="element-28" data-mp="1bdw2eja35yew" data-mpi={i}>
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-navy-900 text-gold-400" data-id="element-29" data-mp="1kchm4hranjh9">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-30" data-mp="1pcm0a14qc24b" />
                </span>
                <h3 className="mt-4 text-lg font-bold leading-snug text-navy-900" data-id="element-31" data-mp="1uadrsu1gpm7z">{a.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-32" data-mp="1z1vqfbg0japs">{a.text}</p>
              </div>;
        })}
        </div>

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-33" data-mp="240745x9fi5da">
          <h3 className="text-center font-serif text-2xl font-bold text-navy-900 sm:text-3xl" data-id="element-34" data-mp="282lnsjkx995m">What makes this different?</h3>
          <p className="mt-4 text-center text-lg text-muted" data-id="element-35" data-mp="2d2gd4ip1tqok">
            Traditional educational resources often focus on explaining concepts. This blueprint
            focuses on organizing professional tasks.
          </p>
          <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-36" data-mp="8z4yfypfgjw9">
            <div className="rounded-2xl border-2 border-dashed border-navy-900/20 p-6" data-id="element-37" data-mp="mp8h6fp3lvgy">
              <p className="text-sm font-bold uppercase tracking-wide text-muted" data-id="element-38" data-mp="hxqftqj5xsvg">Instead of asking</p>
              <p className="mt-2 font-serif text-xl font-semibold text-muted" data-id="element-39" data-mp="wmmw2avdic75">
                “What information should I study next?”
              </p>
            </div>
            <div className="rounded-2xl bg-navy-900 p-6" data-id="element-40" data-mp="rqe9iceujgpy">
              <p className="text-sm font-bold uppercase tracking-wide text-gold-300" data-id="element-41" data-mp="15mjhm3mguuxz">It helps you ask</p>
              <p className="mt-2 font-serif text-xl font-semibold text-white" data-id="element-42" data-mp="10p9i1v5d52wf">
                “What do I need to assess, document, and consider next in this particular case?”
              </p>
            </div>
          </div>
        </div>

        <SectionCTA label="This Is For Me — Get Access" data-id="element-43" data-mp="1hy2aau1l0vgc" />
      </div>
    </section>;
}